import ClimateControlledHero from 'assets/images/psp/PSPHero/climate-controlled-hero.webp';

import ClimateContolledVideo from 'assets/images/psp/FeaturedContentImages/cc-video-content.webp';

import storage5x5 from 'assets/images/icons/psp/climate-controlled/5x5.svg';
import storage5x10 from 'assets/images/icons/psp/climate-controlled/5x10.svg';
import storage5x15 from 'assets/images/icons/psp/climate-controlled/5x15.svg';
import storage10x10 from 'assets/images/icons/psp/climate-controlled/10x10.svg';
import storage10x15 from 'assets/images/icons/psp/climate-controlled/10x15.svg';
import storage10x20 from 'assets/images/icons/psp/climate-controlled/10x20.svg';
import storage10x30 from 'assets/images/icons/psp/climate-controlled/10x30.svg';

import CcRelated1 from 'assets/images/psp/SelfStorage/indoor-climate-controlled-storage-units.webp';
import CcRelated2 from 'assets/images/psp/FeaturedContentImages/cc-related-2.webp';
import CcRelated3 from 'assets/images/psp/College/storage-unit-prices-hero.webp';

import { storageCategories } from 'pages/PSPPage/utils/getPSPLinks';

const ccStorageCostData = {
	title: 'Climate Controlled Storage Cost by Unit Size',
	subtitle: '',
	cardData: [
		{
			imageSrc: storage5x5,
			title: '5x5',
			size: '25 sq ft | 200 cu ft',
			content: '**Average Monthly Cost:** $35.96',
			contentAlign: 'text-center',
		},
		{
			imageSrc: storage5x10,
			title: '5x10',
			size: '50 sq ft | 400 cu ft',
			content: '**Average Monthly Cost:** $54.93',
			contentAlign: 'text-center',
		},
		{
			imageSrc: storage5x15,
			title: '5x15',
			size: '75 sq ft | 600 cu ft',
			content: '**Average Monthly Cost:** $87.24',
			contentAlign: 'text-center',
		},
		{
			imageSrc: storage10x10,
			title: '10x10',
			size: '100 sq ft | 800 cu ft',
			content: '**Average Monthly Cost:** $88.82',
			contentAlign: 'text-center',
		},
		{
			imageSrc: storage10x15,
			title: '10x15',
			size: '150 sq ft | 1,200 cu ft',
			content: '**Average Monthly Cost:** $129.83',
			contentAlign: 'text-center',
		},
		{
			imageSrc: storage10x20,
			title: '10x20',
			size: '200 sq ft | 1,600 cu ft',
			content: '**Average Monthly Cost:** $160.64',
			contentAlign: 'text-center',
		},
		{
			imageSrc: storage10x30,
			title: '10x30',
			size: '300 sq ft | 2,400 cu ft',
			content: '**Average Monthly Cost:** $226.77',
			contentAlign: 'text-center',
		},
	],
};

const reviews = [
	{
		title: 'Easy reservation and confirmation',
		stars: 5,
		text: 'Easy reservation and confirmation with total access and payment for the storage unit online. The unit is clean and climate controlled, and a really beautiful facility!',
		link: 'https://www.trustpilot.com/reviews/6668e8d3655b5a32107bff66',
		customerName: 'Edward',
		date: 'July 22, 2024',
	},
	{
		title: 'Making reservations was so easy!',
		stars: 5,
		text: 'I needed a small climate controlled storage space in a hurry, and SelfStorage had the best price.',
		link: 'https://www.trustpilot.com/reviews/6643ccb7603d6d580747ba61',
		customerName: 'Kem Washington',
		date: 'February 14, 2024',
	},
	{
		title: 'Simple and easy!',
		stars: 5,
		text: 'I was able to look at the sizes and compare prices on SelfStorage.com. I was able to compare climate and non-climate controlled units. I liked that it was self-explanatory and simple.',
		link: 'https://www.trustpilot.com/reviews/66366758ea02080604ca2773',
		customerName: 'Brandy Wilson',
		date: 'March 28, 2024',
	},
	{
		title: 'Reserving a storage space was quick',
		stars: 5,
		text: "Reserving a storage space was quick, easy, and I didn't have to pay anything at the time of reserving, but instead paid once I arrived to check the unit's access. Low to moderate prices, and they have a variety of storage spaces from climate controlled to drive-up access. I would recommend them to my peeps.",
		link: 'https://www.trustpilot.com/reviews/654515a29e19bf686949018a',
		customerName: 'Cherie Hancock',
		date: 'May 10, 2024',
	},
];

const faqs = [
	{
		question: 'What is a climate controlled storage unit?',
		answer:
			'A climate controlled storage unit keeps the temperature between 55°F-80°F and maintains stable humidity levels. This helps prevent damage like warping, rust, or mold, especially for sensitive items such as furniture, electronics, photographs, and tools.\n\n' +
			'There are three types of climate controlled storage:\n' +
			'- **Climate controlled storage** maintains a temperature between 55-80°F.\n' +
			'- **Air-conditioned or heated storage** uses hot or cool air to regulate temperature, and\n' +
			'- **Humidity-controlled storage** regulates moisture by keeping humidity levels around 55%.',
	},
	{
		question: 'What items need climate control?',
		answer:
			'Climate controlled storage is highly recommended for sensitive items like:\n\n' +
			'- Furniture and mattresses\n' +
			'- Electronics and appliances\n' +
			'- Artwork and musical instruments\n' +
			'- Photos, books, and documents\n' +
			'- Vinyl records and collectibles\n' +
			'- Wine, candles, and leather goods.',
	},
	{
		question: 'Are climate controlled storage units more expensive?',
		answer: 'Climate controlled units are more expensive than standard units. How much more you pay depends on where you live and the unit size. You can expect to pay 20-50 percent more per month compared to standard units.',
	},
	{
		question: 'Do climate controlled units come with insurance?',
		answer:
			"Climate controlled units don't automatically include insurance, but many storage facilities offer it as a separate add-on.\n\n" +
			'Insurance can help cover losses from theft, fire, or other unexpected events, but may not always include damage from temperature or humidity.\n\n' +
			"Be sure to check with your facility to confirm what's covered and review the policy details before you commit.",
	},
	{
		question:
			'How to wrap furniture for long term storage in a climate controlled unit?',
		answer:
			"There's an art to how to pack furniture for climate controlled storage. Properly wrapping furniture for climate controlled storage protects your valuable pieces from dust, scratches, and moisture while preserving their condition for years.\n\n" +
			'**1. Clean Your Furniture:** Thoroughly clean all furniture and apply conditioners to leather and wood surfaces before wrapping.\n\n' +
			'**2. Add at Least 2 Layers of Protection:** Start with moving blankets for cushioning, then add a loose layer of plastic wrap for moisture protection.\n\n' +
			'**3. Secure Properly:** Use packing tape to secure materials without over-tightening, maintaining airflow around furniture.\n\n' +
			'**4. Floor Protection:** Place plastic sheeting on your storage unit floor to prevent ground moisture from seeping up.\n\n' +
			'While climate controlled units maintain consistent temperature and humidity, proper wrapping remains essential for dust protection and preventing scratches from neighboring items. This combination provides optimal protection for wooden, leather, and antique furniture.',
	},
];

export const ClimateControlledContent = {
	type: 'Climate Controlled',
	reviews: reviews,
	sections: [
		{
			title: 'Climate Controlled Storage Hero',
			background: 'default',
			modules: [
				{
					type: 'hero',
					id: 'climate-controlled-hero',
					props: {
						content: {
							title: 'Find Affordable Climate Controlled Self Storage',
							description:
								"Whether you're storing household items during a move, preparing for home renovation, or winterizing your vehicles, self storage with climate control adds a layer of protection you can count on. With a consistent temperature between 55°F and 80°F and stable humidity, it's an ideal storage environment for furniture, electronics, tools, or documents.\n\n" +
								'**SelfStorage.com** helps you find and compare units with climate control, 24/7 access, and security features so you can store with confidence.',
							image: ClimateControlledHero,
							CTAtext: 'Find Self Storage',
						},
					},
				},
			],
		},
		{
			title: 'climate controlled video content',
			noPaddingBottom: true,
			background: 'blueGradient',
			modules: [
				{
					title: 'Get the Most Out of Your Climate Controlled Storage Unit',
					type: 'video',
					background: 'blueGradient',
					props: {
						content: {
							title: 'Get the Most Out of Your Climate Controlled Storage Unit',
							description:
								'Pairing climate control with the right features ensures your storage setup is both secure and easy to access.',
							imageSrc: ClimateContolledVideo,
							videoSrc: '',
							suffixText:
								"Whether you're looking for 24-hour access, drive-up convenience, electricity, or added security, **SelfStorage.com** makes it easy to filter and compare units with the features you need.",
						},
					},
				},
			],
		},
		{
			title: 'Climate-Controlled Storage Size Chart',
			background: 'white',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: ccStorageCostData.title,
						description: ccStorageCostData.subtitle,
						cardData: ccStorageCostData.cardData,
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'lighterBlue',
			modules: [
				{
					type: 'reviews',
					props: {
						reviewsData: {
							reviews,
							headerTitle: 'Climate Controlled Self Storage: ',
						},
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			background: 'white',
			modules: [
				{
					type: 'faqs',
					props: {
						content: {
							header: 'Climate Controlled Self Storage FAQs',
							faqs,
						},
					},
				},
			],
		},
		{
			title: 'related content',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: {
							heading:
								'Learn All About Climate Controlled Self Storage',
							type: 'climateControlledStorageRelatedContent',
							id: 'climate-controlled-storage-related-content',
							data: {
								slug: 'climate-controlled-storage-related-content',
								unitCards: [
									{
										title: 'Storage Tips',
										date: 'November 4, 2025',
										image: CcRelated1,
										url: 'https://www.selfstorage.com/blog/what-is-climate-controlled-storage-2/',
										content:
											'Why Would You Need a Climate Controlled Storage Unit?',
									},
									{
										title: 'Storage Tips',
										date: 'October 29, 2025',
										image: CcRelated2,
										url: 'https://www.selfstorage.com/blog/self-storage-improves-garage-shed-organization/',
										content:
											'5 Ways Self Storage Improves Garage & Shed Organization',
									},
									{
										title: 'Moving',
										date: 'September 18, 2025',
										image: CcRelated3,
										url: 'https://www.selfstorage.com/blog/storage-unit-prices/',
										content:
											'Storage Unit Prices: How Much is a Storage Unit in 2025?',
									},
								],
							},
						},
					},
				},
			],
		},
		{
			title: 'Links to other PSPs',
			background: 'lighterBlue',
			modules: [
				{
					type: 'links',
					props: {
						heading: {
							headingName: 'More Ways to Store',
						},
						linksList: storageCategories.climateControlled,
					},
				},
			],
		},
		{
			title: 'nearby cities',
			modules: [
				{
					type: 'storageNearYou',
					props: {
						type: 'Climate Controlled',
					},
				},
			],
		},
	],
};
